import piniaPluginPersistedState from 'pinia-plugin-persistedstate'
import { createPinia } from 'pinia'


// Initialize pinia //
const pinia = createPinia();
pinia.use(piniaPluginPersistedState)

export default pinia;